import React from 'react';
import { func, bool, string } from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';
import AuthFormBox from 'app/components/AuthFormBox';
import { PASSWORD_RECOVERY_FORM } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';
import { gaTrackPageView } from 'services/AnalyticsService';

import PasswordRecovery from './layout';
import stylesJS from './styles';
import styles from './styles.module.scss';

const DOCUMENT_TYPE = 'document_type';
const DOCUMENT_NUMBER = 'document_number';

class PasswordRecoveryContainer extends React.PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.SIGN_IN_PASSWORD_RECOVERY);
  }

  render() {
    const { handleSubmit, loading, documentNumber, documentType, submitFailed, invalid } = this.props;

    return (
      <form onSubmit={handleSubmit} style={stylesJS.container}>
        <AuthFormBox title={message('Signin:recoverPassword')}>
          <PasswordRecovery loading={loading} documentType={documentType} documentNumber={documentNumber} />
        </AuthFormBox>
        {!loading && [
          <UTButton
            disabled={submitFailed && invalid}
            key="submit"
            uppercase
            className={styles.submit}
            type="submit"
          >
            {message('Signin:sendRequest')}
          </UTButton>,
          <Link key="goBack" style={stylesJS.goBack} to={ROUTES.SIGN_IN}>
            <UTLabel primary semibold small>
              {message('Commons:back')}
            </UTLabel>
          </Link>
        ]}
      </form>
    );
  }
}

PasswordRecoveryContainer.propTypes = {
  handleSubmit: func.isRequired,
  loading: bool,
  documentType: string,
  documentNumber: string,
  submitFailed: bool,
  invalid: bool
};

const formSelector = formValueSelector(PASSWORD_RECOVERY_FORM);

const mapStateToProps = store => ({
  documentType: formSelector(store, DOCUMENT_TYPE),
  documentNumber: formSelector(store, DOCUMENT_NUMBER),
  loading: store.auth.recoveryPasswordRequestLoading
});

export default connect(mapStateToProps)(
  reduxForm({ form: PASSWORD_RECOVERY_FORM })(Radium(PasswordRecoveryContainer))
);
